<form nz-form class="address-form mr-2" autocomplete="off">
	<div class="title-30 color-blue">
		{{ "global.org_settings.roles.title" | translate }}
	</div>
	<div class="subtitle-30 color-grey">
		{{ "global.org_settings.roles.subtitle" | translate }}
	</div>
	<nz-input-group [nzAddOnAfter]="suffixIconButton" nzSize="large" class="table-searchbox">
		<input placeholder="input here" nz-input (change)="onChange($event.target.value)"/>
		<ng-template nzSize="medium" #suffixIconButton>
			<button nz-button class="transparent" nzSearch>
				<i nz-icon nzType="search" nzTheme="outline"></i>
			</button>
		</ng-template>
	</nz-input-group>
	<div class="table-modification float-right mb-1">
		<button nz-button (click)="displayCreateRoleModal()" class="add-button border-radius-5 color-blue border-color-blue" [nzType]="'Primary'">
			<i nz-icon nzType="plus" nzTheme="outline"></i>Add
		</button>
		<button nz-button class="btn-danger border-radius-5" [nzType]="'Danger'" (click)="deleteAllSelectedRoles()">
			<i nz-icon nzType="delete" nzTheme="outline"></i>Delete All
		</button>
	</div>
	<nz-table #rowSelectionTable nzShowSizeChanger [nzData]="listOfData"
		(nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzShowPagination]="false">
		<thead>
			<tr>
				<th [nzWidth]="columnWidth" [nzAlign]="'center'" [(nzChecked)]="checked"
					[nzIndeterminate]="indeterminate" (nzCheckedChange)="onAllChecked($event)">
				</th>
				<th *ngFor="let column of listOfColumn" [nzSortOrder]="column.sortOrder" [nzSortFn]="column.sortFn"
					[nzSortDirections]="column.sortDirections" [nzWidth]="column?.width">
					{{ column.title }}
				</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let data of rowSelectionTable.data">
				<td [nzAlign]="'center'" [nzChecked]="setOfCheckedId.has(data.id)"
					(nzCheckedChange)="onItemChecked(data.id, $event)"></td>
				<td>{{ data.name }}</td>
				<td>{{ data.systemRole }}</td>
				<td>
					<a class="color-blue mr-3">Edit</a>
					<a class="color-danger">Delete</a>
				</td>
			</tr>
		</tbody>
	</nz-table>
</form>
<nz-modal [(nzVisible)]="createRoleModalVisible" (nzOnCancel)="handleCancel(createRoleForm)"
	(nzOnOk)="handleOk(createRoleForm)" [nzTitle]="modalTitle" nzCentered [nzStyle]="createRoleModalStyle">
	<ng-template #modalTitle class="font-800">
		Create New Role (Edit Role)
	</ng-template>
	<ng-container *nzModalContent>
		<div class="center">
			<form [formGroup]="createRoleForm" class="half-width">
				<nz-form-item class="input-field title-14">
					<nz-form-control>
						<app-input-field [size]="'large'" [form]="createRoleForm" [label]="'Role Name'"
							placeholder="role name" [formName]="'roleName'">
						</app-input-field>
					</nz-form-control>
				</nz-form-item>
			</form>
		</div>
		<div class="color-grey center mb-1">Check the Permission to grant on this role.</div>
		<nz-collapse nzAccordion>
			<nz-collapse-panel *ngFor="let panel of panels" [nzHeader]="header" [nzActive]="panel.active">
				<div *ngFor="let child of panel['childPanel']" class="role-modal-information ml-1">
					<label nz-checkbox>{{ child.name }} content</label>
				</div>
				<ng-template #header>
					<label nz-checkbox>{{ panel.name }}</label>
				</ng-template>
			</nz-collapse-panel>
		</nz-collapse>
	</ng-container>

	<div *nzModalFooter>
		<button nz-button nzType="default" class="color-grey border-none"
			(click)="handleCancel(createRoleForm)">Back</button>
		<button nz-button [disabled]="createRoleForm.invalid" nzType="default"
			class="border-radius-5 border-color-blue color-blue" (click)="handleOk(createRoleForm)">Create Role</button>
	</div>
</nz-modal>
